module.exports = __webpack_public_path__ + "img/culture_2.41ba6fa2.png";